export default {
  tableTabs: [
    {
      title: "همه‌ رمزارز‌ها",
      id: 1
    },
    {
      title: "علاقه‌مندی‌ها",
      id: 2
    }
  ],
  searchInputPlaceholder: "جستجو براساس نام ارز و یا نام اختصاری...",
  categoriesMenu: ["محبوب ترین", "ارزان ترین", "گران ترین"],
  headers: [
    {
      text: "#",
      align: "start",
      sortable: true,
      value: "rank",
      width: 180
    },
    {
      text: "نام ارز",
      align: "start",
      sortable: true,
      value: "name_locale",
      width: 180
    },
    {
      text: "قیمت (USDT)",
      value: "price",
      align: "right",
      sortable: true,
      width: 180
    },
    {
      text: "تغییرات 24h",
      value: "daily_change_percent",
      align: "right",
      sortable: true,
      width: 180
    },
    {
      text: "قیمت فروش ما (ریال)",
      value: "price_buy",
      align: "right",
      sortable: true,
      width: 180
    },
    {
      text: "قیمت خرید ما (ریال)",
      value: "price_sell",
      align: "right",
      sortable: true,
      width: 180
    },
    {
      text: "حجم بازار (USDT)",
      value: "market_cap",
      align: "right",
      sortable: true,
      width: 180
    },
    {
      text: "",
      value: "",
      align: "end",
      sortable: false,
      width: 1
    }
    /*{
          text: "نمودار قیمت",
          value: "diagramPrice",
          align: "center",
          sortable: false
        },*/
    /*{ text: "عملیات", value: "actions", align: "center", sortable: false }*/
  ],
  noResults: "نتیجه‌ای یافت نشد.",
  noResultsForFave: " لیست علاقه‌مندی‌های شما خالی است"
};
